import { type Interceptor } from '@connectrpc/connect';
import { PublicApiError } from '@/api/errors';

/**
 * This interceptor catches errors thrown by the transport and converts them into PublicApiError
 * instances.
 *
 * It must stay the last interceptor in the array: that makes it the innermost one, so errors thrown
 * by earlier interceptors — e.g. `AccessControlError` from the permissions interceptor — bypass this
 * conversion and keep their identity.
 */
export const connectErrorInterceptor: Interceptor = (next) => async (req) => {
  try {
    return await next(req);
  } catch (reason) {
    throw await PublicApiError.fromAsync(reason);
  }
};
